<template>
  <div style="background: #fafafa">
    <div class="body-max-width-no-padding">
      <div class="mock-footer relative">
        <div class="bottom-screen">
          <div class="footer-menu relative overflow-hidding">
            <div style="max-width: 500px; margin: auto">
              <div style="overflow: hidden">
                <div class="flex-center" style="float: left; display: flex">
                  <div>
                    <div class="total-label fs-17 fw-500 fc-52684F mr-10">
                      {{ $t("total") }}
                    </div>
                  </div>
                  <div>
                    <div
                      class="price-label fs-17 fw-500 ml-auto"
                      style="text-align: right"
                    >
                      {{ numberWithCommas(1000) }} {{ $t("baht") }}
                    </div>
                    <div
                      class="price-label right fs-16 fw-500 fc-9A9A9A"
                      style="text-decoration: line-through"
                    >
                      {{ numberWithCommas(1000) }} {{ $t("baht") }}
                    </div>
                  </div>
                </div>
                <div style="float: right; display: flex">
                  <div @click="checkDate" class="payment-button right">
                    <p style="margin: auto">ชำระเงิน</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="package_for_you" class="body-max-width">
      <Header back="/home" menu="disable" :title="$t('cart')"></Header>
    </div>
    <div class="body-max-width row cart-header">
      <div class="col-6 box">
        <div class="detail">
          {{ $t("myOrder") }}
          <div v-if="orderCount > 0" class="noti">{{ orderCount }}</div>
        </div>
      </div>
      <div class="col-6 box select">
        <div class="detail">Success</div>
      </div>
    </div>
    <div class="body-max-width pt-10">
      <div class="flex-center">
        <div @click="selectAllPackage()" class="checkbox-container ml-auto">
          <div v-if="selected_all" class="checked"></div>
        </div>
        <div @click="selectAllPackage()" class="fc-696969 fs-14 fw-500 ml-10">
          Select all
        </div>
      </div>

      <div class="relative flex">
        <div class="status">ที่ต้องชำระ</div>
        <div class="category-arrow relative flex-mid">
          <div :class="`arrow-show mt-2 show`">
            <svg
              width="9"
              height="6"
              viewBox="0 0 9 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.66952 0.246055C8.51098 0.0884582 8.29653 0 8.07298 0C7.84944 0 7.63498 0.0884582 7.47644 0.246055L4.43875 3.24144L1.44337 0.246055C1.28483 0.0884582 1.07037 0 0.846829 0C0.623287 0 0.408828 0.0884582 0.250291 0.246055C0.170982 0.324716 0.108033 0.418302 0.0650749 0.521413C0.0221168 0.624525 0 0.735122 0 0.846824C0 0.958527 0.0221168 1.06912 0.0650749 1.17224C0.108033 1.27535 0.170982 1.36893 0.250291 1.44759L3.83798 5.03529C3.91664 5.11459 4.01023 5.17754 4.11334 5.2205C4.21645 5.26346 4.32705 5.28558 4.43875 5.28558C4.55045 5.28558 4.66105 5.26346 4.76416 5.2205C4.86728 5.17754 4.96086 5.11459 5.03952 5.03529L8.66952 1.44759C8.74883 1.36893 8.81178 1.27535 8.85474 1.17224C8.8977 1.06912 8.91981 0.958527 8.91981 0.846824C8.91981 0.735122 8.8977 0.624525 8.85474 0.521413C8.81178 0.418302 8.74883 0.324716 8.66952 0.246055Z"
                fill="black"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="package-container">
        <div
          class="package mb-22"
          v-for="(value, index) in packageList"
          :key="value.id"
        >
          <div class="relative flex">
            <div class="mr-auto flex-center flex-wrap">
              <!-- <div class="mr-auto " > -->
              <div
                @click="selectPackage(index, value.id)"
                class="checkbox-container"
              >
                <div v-if="value.select" class="checked"></div>
              </div>
            </div>
            <div class="title">
              {{ value.title }}
              <p class="order-nubmer">Order Number : {{ value.orderNumber }}</p>
            </div>

            <div class="mr-auto flex-center flex-wrap">
              <div
                class="icon-arrow relative flex-mid"
                @click="value.statusShow = !value.statusShow"
              >
                <div
                  :class="`arrow-show mt-2 ${value.statusShow ? 'show' : ''}`"
                >
                  <svg
                    width="9"
                    height="6"
                    viewBox="0 0 9 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.66952 0.246055C8.51098 0.0884582 8.29653 0 8.07298 0C7.84944 0 7.63498 0.0884582 7.47644 0.246055L4.43875 3.24144L1.44337 0.246055C1.28483 0.0884582 1.07037 0 0.846829 0C0.623287 0 0.408828 0.0884582 0.250291 0.246055C0.170982 0.324716 0.108033 0.418302 0.0650749 0.521413C0.0221168 0.624525 0 0.735122 0 0.846824C0 0.958527 0.0221168 1.06912 0.0650749 1.17224C0.108033 1.27535 0.170982 1.36893 0.250291 1.44759L3.83798 5.03529C3.91664 5.11459 4.01023 5.17754 4.11334 5.2205C4.21645 5.26346 4.32705 5.28558 4.43875 5.28558C4.55045 5.28558 4.66105 5.26346 4.76416 5.2205C4.86728 5.17754 4.96086 5.11459 5.03952 5.03529L8.66952 1.44759C8.74883 1.36893 8.81178 1.27535 8.85474 1.17224C8.8977 1.06912 8.91981 0.958527 8.91981 0.846824C8.91981 0.735122 8.8977 0.624525 8.85474 0.521413C8.81178 0.418302 8.74883 0.324716 8.66952 0.246055Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div v-if="value.statusShow" class="line-package mt-18"></div>
          <div
            :class="`expend-package mt-10 ${value.statusShow ? 'showing' : ''}`"
          >
            <div class="sub-package" v-for="val in value.package" :key="val.id">
              <div class="flex">
                <div class="checkbox fs-16">•</div>
                <div class="body px-3">
                  <div class="include-label">
                    โปรแกรมตรวจระดับไขมันในตับและตรวจภาวะตับแข็งด้วยเครื่อง
                    Fibro scan
                  </div>
                </div>
                <div class="pricing Avenir">
                  <div v-if="val.salePrice">
                    <div class="fc-C31212 ml-auto">
                      {{ numberWithCommasLine(val.price - val.salePrice) }}
                    </div>
                    <div class="sale">
                      {{ numberWithCommasLine(val.price) }}
                    </div>
                  </div>
                  <div v-else>{{ numberWithCommasLine(val.price) }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="line-package"></div>

          <div class="relative flex total-price">
            <div class="title">
              {{ $t("total") }}
            </div>

            <div class="mr-auto flex-center flex-wrap price">
              {{ value.priceAll }}
            </div>
          </div>
        </div>
        <div
          class="package mb-22"
          v-for="(value, index) in packageList"
          :key="value.id"
        >
          <div class="flex-center relative">
            <div class="mr-auto flex-center flex-warp">
              <div
                @click="selectPackage(index, value.id)"
                class="checkbox-container"
              >
                <div v-if="value.select" class="checked"></div>
              </div>
            </div>
            <div class="title">
              {{ value.title }}
              <p class="order-nubmer">Order Number : {{ value.orderNumber }}</p>
            </div>

            <div
              class="icon-arrow relative flex-mid"
              @click="value.statusShow = !value.statusShow"
            >
              <div :class="`arrow-show mt-2 ${value.statusShow ? 'show' : ''}`">
                <svg
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.66952 0.246055C8.51098 0.0884582 8.29653 0 8.07298 0C7.84944 0 7.63498 0.0884582 7.47644 0.246055L4.43875 3.24144L1.44337 0.246055C1.28483 0.0884582 1.07037 0 0.846829 0C0.623287 0 0.408828 0.0884582 0.250291 0.246055C0.170982 0.324716 0.108033 0.418302 0.0650749 0.521413C0.0221168 0.624525 0 0.735122 0 0.846824C0 0.958527 0.0221168 1.06912 0.0650749 1.17224C0.108033 1.27535 0.170982 1.36893 0.250291 1.44759L3.83798 5.03529C3.91664 5.11459 4.01023 5.17754 4.11334 5.2205C4.21645 5.26346 4.32705 5.28558 4.43875 5.28558C4.55045 5.28558 4.66105 5.26346 4.76416 5.2205C4.86728 5.17754 4.96086 5.11459 5.03952 5.03529L8.66952 1.44759C8.74883 1.36893 8.81178 1.27535 8.85474 1.17224C8.8977 1.06912 8.91981 0.958527 8.91981 0.846824C8.91981 0.735122 8.8977 0.624525 8.85474 0.521413C8.81178 0.418302 8.74883 0.324716 8.66952 0.246055Z"
                    fill="black"
                  />
                </svg>
              </div>
            </div>
          </div>
          <div :class="`expend-package ${value.statusShow ? 'showing' : ''}`">
            <div class="sub-package" v-for="val in value.package" :key="val.id">
              <div v-if="value.statusShow" class="line-package mt-18"></div>
              <div class="flex">
                <div class="checkbox mt-10">
                  <div
                    @click="selectSubPackage(index, val.id)"
                    class="checkbox-container"
                  >
                    <div v-if="val.select" class="checked"></div>
                  </div>
                </div>
                <div class="body px-3">
                  <div class="include-label mt-3">
                    โปรแกรมตรวจระดับไขมันในตับและตรวจภาวะตับแข็งด้วยเครื่อง
                    Fibro scan
                  </div>
                  <div class="quality">
                    <div class="icon">
                      <svg viewBox="0 0 10 10" x="0" y="0" class="icon-svg">
                        <polygon
                          style="stroke: #b9b9b9; stroke-width: 1"
                          points="4.5 4.5 3.5 4.5 0 4.5 0 5.5 3.5 5.5 4.5 5.5 10 5.5 10 4.5"
                        ></polygon>
                      </svg>
                    </div>
                    <div class="number">1</div>
                    <div class="icon">
                      <svg viewBox="0 0 10 10" x="0" y="0" class="icon-svg">
                        <polygon
                          style="stroke: #b9b9b9; stroke-width: 1"
                          points="10 4.5 5.5 4.5 5.5 0 4.5 0 4.5 4.5 0 4.5 0 5.5 4.5 5.5 4.5 10 5.5 10 5.5 5.5 10 5.5"
                        ></polygon>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="pricing Avenir fs-14 fw-500 mt-10">
                  <div v-if="val.salePrice" class="pricing-sale-mobile">
                    <div class="fc-C31212 ml-auto">
                      {{ numberWithCommasLine(val.price - val.salePrice) }}
                    </div>
                    <div class="sale">
                      {{ numberWithCommasLine(val.price) }}
                    </div>
                  </div>
                  <div v-else>{{ numberWithCommasLine(val.price) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 20rem">&nbsp;</div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import Header from "@/components/HomeNav.vue";
import axios from "axios";
import * as config from "@/assets/js/config.js";
var AmazonCognitoIdentity = require("amazon-cognito-identity-js");

export default defineComponent({
  name: "Cart",
  components: {
    Header,
  },
  data() {
    return {
      page: "myOrder",
      orderCount: 0,
      selected_all: false,
      lang: "",
      accessToken: "",
      orderList: {},
      packageList: [
        {
          title: "Total Health Solution",
          orderNumber: "09d035b1-29a1-46f5-86a9-89f04d577340",
          id: "Health_check5f864843",
          statusShow: true,
          select: false,
          riskStatus: "high",
          package: [
            {
              select: true,
              id: "Health_check5fssdf864843",
              price: 112290,
              salePrice: 300,
              include: [
                "ตรวจความสมบูรณ์ของเลือด",
                "ตรวจความสมบูรณ์ของเลือด2",
                "ตรวจความสมบูรณ์ของเลือด3",
              ],
            },
            {
              select: false,
              id: "Health_check5f86ads4843",
              price: 1190,
              include: ["ตรวจความสมบูรณ์ของเลือด"],
            },
            {
              select: false,
              id: "Health_check5f86ads4843",
              price: 1190,
              include: ["ตรวจความสมบูรณ์ของเลือด"],
            },
            {
              select: false,
              id: "Health_check5f86ads4843",
              price: 1190,
              include: ["ตรวจความสมบูรณ์ของเลือด"],
            },
            {
              select: true,
              id: "Health_check5fssdf864843",
              price: 112290,
              salePrice: 300,
              include: [
                "ตรวจความสมบูรณ์ของเลือด",
                "ตรวจความสมบูรณ์ของเลือด2",
                "ตรวจความสมบูรณ์ของเลือด3",
              ],
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.accessToken = this.$cookies.get("access_token");
    this.lang = this.$cookies.get("lang");
    this.getPending();
  },
  methods: {
    changePage(page) {
      this.page = page;
      if (page == "myOrder") {
        this.getPending();
      } else if (page == "success") {
        this.getPaid();
      }
    },
    getPending() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/purchase/get/pending-payment",
          {},
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
          this.orderCount = res.data.length;
          const data = this.groupBy(res.data, "purchaseStatus");
          console.log("data", data);
          // let list = []
          // for (const property in data) {
          //   list.push({
          //     purchaseStatus: property,
          //     statusShow: true,
          //     select: true,
          //     package: data[property],
          //   });
          // }
          // console.log(list)
        });
    },
    getPaid() {
      axios
        .post(
          process.env.VUE_APP_TOTALHEALTHAPI_URL +
            "/total-health-solution/purchase/get/paid",
          {},
          {
            headers: {
              "Accept-Language": this.lang,
              Authorization: "Bearer " + this.accessToken,
            },
          }
        )
        .then((res) => {
          console.log(res.data);
        });
    },
    groupBy(xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    numberWithCommasLine(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + ".-";
    },
    numberWithCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    totalByOrder() {
      console.log(5555);
    },
    selectSubPackage(listId, packageId) {
      const arr = this.packageList[listId].package;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id == packageId) {
          this.packageList[listId].package[i].select = !arr[i].select;
        }
      }
      let sameValue = true;
      let statusFirstSubPackage = this.packageList[listId].package[0].select;
      for (let i = 0; i < arr.length; i++) {
        if (
          this.packageList[listId].package[i].select !== statusFirstSubPackage
        ) {
          sameValue = false;
        }
      }
      if (sameValue) {
        this.packageList[listId].select = statusFirstSubPackage;
        this.checkPackageSelected();
      }
    },
    selectAllPackage() {
      for (let i = 0; i < this.packageList.length; i++) {
        this.packageList[i].select = !this.selected_all;
        for (
          let index = 0;
          index < this.packageList[i].package.length;
          index++
        ) {
          this.packageList[i].package[index].select = !this.selected_all;
        }
      }
      this.checkPackageSelected();
    },
    selectPackage(listId) {
      const arr = this.packageList[listId].package;
      const value = !this.packageList[listId].select;
      this.packageList[listId].select = value;
      for (let i = 0; i < arr.length; i++) {
        this.packageList[listId].package[i].select = value;
      }
      this.checkPackageSelected();
    },
    checkPackageSelected() {
      let sameValue = true;
      let statusFirstSubPackage = this.packageList[0].select;
      for (let i = 0; i < this.packageList.length; i++) {
        if (this.packageList[i].select !== statusFirstSubPackage) {
          sameValue = false;
        }
      }
      if (sameValue) {
        this.selected_all = statusFirstSubPackage;
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.cart-header {
  padding: 0px;
  margin-top: 3.3rem;
  // height: 3.3rem;
  font-size: 1.4rem;
  color: #9b9b9b;
  background: white;
  text-align: center;
  .box {
    padding: 10px 0 7px 0;
  }
  .box.select {
    border-bottom: 3px solid #206b5e;
    color: #206b5e;
    font-weight: 500;
  }
  .detail {
    margin: auto;
    width: fit-content;
    position: relative;
    // background: red;
  }
  .noti {
    background: #206b5e;
    padding: 0px 6px;
    width: fit-content;
    font-size: 12px;
    color: white;
    border-radius: 30px;

    display: flex;
    position: absolute;
    top: -0.5rem;
    left: 8.8rem;
    // border-radius: 4.3rem;
    // background-color: #206b5e;
  }
}
.expend-package {
  border-radius: 0.4rem;
  min-height: 0rem;
  max-height: 0rem;
  transform-origin: top center;
  transform: rotate(0.1deg);
  transition: all 0.3s;
  overflow: hidden;
}
.showing {
  transition: all 0.6s;
  min-height: 10rem;
  max-height: 100rem;
}

.status {
  //right
  // width: 100%;
  //next text
  margin-right: 10px;
  ////
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.category-arrow {
  // margin-left: 7rem;
  cursor: pointer;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 2.5rem;
  background-color: #f3f3e7;
  filter: drop-shadow(3px 4px 4px rgba(148, 148, 148, 0.25));
  .arrow-show {
    position: absolute;
    transform: rotate(180deg);
    transition: 0.3s;
  }
  .arrow-show.show {
    position: absolute;
    transform: rotate(0deg);
  }
}
.package-container {
  margin-top: 1.4rem;
  border-radius: 4rem;
  .package {
    background-color: #fff;
    padding: 2rem 2rem;
    border-radius: 1rem;
    box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
      5px 5px 10px rgba(163, 162, 162, 0.25);
    .title {
      color: #020202;
      font-size: 1.5rem;
      font-weight: 500;
      width: 100%;
      padding: 0px 10px;
    }
    .order-nubmer {
      font-size: 1.2rem;
      margin: 0px;
      font-weight: 100;
    }
    .status {
      padding: 2px 12px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      background: gray;
      text-transform: capitalize;
    }
    .status.high {
      background: #e45757;
    }
    .status.moderate {
      background: #e7c74e;
    }
    .status.low {
      background: #6db557;
    }
    .price {
      color: #000;
      font-size: 2rem;
    }
    .price-changed {
      .old-price {
        color: #b9b9b9;
        font-weight: 500;
        font-size: 2.5rem;
        text-decoration: line-through;
      }
      .price {
        color: #c31212;
        text-decoration: none;
        font-size: 2rem;
      }
    }
    .icon-arrow {
      // margin-left: 7rem;
      cursor: pointer;
      width: 4rem;
      height: 3.3rem;
      border-radius: 3.3rem;
      background-color: #f3f3e7;
      filter: drop-shadow(3px 4px 4px rgba(148, 148, 148, 0.25));
      .arrow-show {
        position: absolute;
        transform: rotate(180deg);
        transition: 0.3s;
      }
      .arrow-show.show {
        position: absolute;
        transform: rotate(0deg);
      }
    }
    .line-package {
      width: 100%;
      height: 0.1rem;
      background: #cfcfcf;
    }
    .sub-package {
      padding: 0px 0rem 5px 1rem;
      .checkbox {
        // width: 3rem;
      }
      .body {
        width: 100%;
      }
      .pricing {
        font-size: 1.3rem;
        // width: 5rem;
        text-align: right;
        .sale {
          color: #b9b9b9;
          font-size: 1.2rem;
          text-decoration: line-through;
        }
      }
      .quality {
        border: 1px solid #b9b9b9;
        width: fit-content;
        .number {
          border: 1px solid #b9b9b9;
          display: inline;
          padding: 0px 10px;
          font-size: 1.4rem;
          color: #b9b9b9;
          font-weight: 500;
        }
        .icon {
          // border: 1px solid #b9b9b9;
          display: inline;
          padding: 0px 5px;
          margin: 0px;
        }
        .icon-svg {
          margin-top: -4px;
          height: 1em;
        }
      }
      @media only screen and (min-width: 600px) {
        .pricing {
          width: 11rem;
          .sale {
            margin-left: 1rem;
          }
        }
      }
      .include-label {
        color: #999999;
        font-size: 1.2rem;
      }
    }
    .total-price {
      margin-top: 1rem;
      .title {
        font-size: 1.6rem;
      }

      .price {
        font-size: 1.6rem;
      }
    }
  }
}
.mock-footer {
  width: 100%;
}
.bottom-screen {
  position: fixed;
  width: 100%;
  // max-width: calc(500px);
  bottom: 0;
  z-index: 99;
}
.footer-menu {
  // height: 14rem;
  padding: 1.6rem 2rem;
  // max-width: calc(100% - 3rem);
  bottom: 0;
  background-color: #d5e3d5;
  border-radius: 1.5rem 1.5rem 0 0;
}
.border-bottom-line {
  border-bottom: 0.1rem solid #eaeaea;
}
.select-payment {
  height: 4.4rem;
  padding-left: 1.6rem;
  margin-left: 1rem;
  border-radius: 1rem;
  transition: 0.3s;
  border: 1px solid transparent;
  cursor: pointer;

  &:hover {
    background-color: #e5e5e530;
    border: 1px solid #3fbeb680;
  }
  .image {
    width: 2.6rem;
    margin-right: 1.4rem;
    > img {
      max-width: 2.6rem;
      max-height: 2.6rem;
    }
  }
  .label {
    font-size: 1.4rem;
    color: #000;
    font-weight: 300;
  }
}
.select-payment.selected {
  border: 1px solid #3fbeb6;
}

.cart-button {
  display: flex;
  background-color: white;
  width: 4rem;
  height: 4rem;
  border-radius: 2rem;
  align-items: center;
  text-align: center;
  margin: 0px;
  padding: 0px;
  @media only screen and (max-width: 600px) {
    font-size: 1rem;
    // margin-left: 1.5rem;
    width: 4rem;
    height: 4rem;
  }
  @media only screen and (max-width: 400px) {
    font-size: 1rem;
    // margin-left: 1rem;
    width: 4rem;
    height: 4rem;
  }
}
.payment-button {
  display: flex;
  background-color: white;
  font-size: 1.5rem;
  width: 8rem;
  height: 4rem;
  border-radius: 2rem;
  align-items: center;
  margin-left: 1rem;
  right: 0;
  margin-right: 0rem;
  @media only screen and (max-width: 600px) {
    font-size: 1.2rem;
    margin-left: 1rem;
    width: 10rem;
    border-radius: 1.8rem;
  }
  @media only screen and (max-width: 400px) {
    height: 4rem;
    width: 8rem;
    font-size: 1.2rem;
    margin-left: 1rem;
  }
}
.price-label {
  font-size: 1.4rem;
}
</style>

<style lang="scss">
#package_for_you {
  .hospital-input {
    width: 100%;
    height: 4.1rem;
    border-radius: 1.5rem;
    .el-input__inner {
      height: 5.1rem;
      border-radius: 1.5rem;
      border: 0;
      outline: 0;
      box-shadow: none;
      border: 1px solid #fff;
      background-color: #fff;
      transition: 0.3s;
      box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
        5px 5px 10px rgba(163, 162, 162, 0.25);
      &:focus {
        border: 1px solid #206b5e;
        box-shadow: -5px -5px 5px rgba(232, 232, 232, 0.25),
          5px 5px 10px rgba(163, 162, 162, 0.25);
      }
    }
  }
}
</style>
